import { Helmet } from "react-helmet"
import BannerContacto from "../components/BannerContacto"
import Footer from "../components/Footer"
import NavBar from "../NavBar"
import NavBarTop from "../NavBarTop"
import env from '../config';
let urlMedia = env.url

function Experiencia() {
    return (
        <>
            <Helmet>
                <title>Experiencia sinotruk | Vehicentro</title>
                <meta name="description" content="Experiencia sinotruk" />
            </Helmet>
            <NavBarTop />
            <Content1 />
            <Block2 />
            <BannerContacto />
            <Footer />
        </>
    )
}

function Content1() {
    return (
        <div className="block4 boxBlock boxesIni posRelative content3">


            <div className="boxRight">
                <div className="boxLeft c7h">
                    <video width="320" height="240" autoPlay={true} preload="none" playsInline={true} controls loop muted src={urlMedia + "/testimonios/sinotrukeros/testimonial1.mp4"} className="videoWidth" />
                </div>
            </div>

            <div className="boxRight">
                <div className="boxLeft c7h">
                    <video width="320" height="240" autoPlay={true} preload="none" playsInline={true} controls loop muted src={urlMedia + "/testimonios/sinotrukeros/testimonial2.mp4"} className="videoWidth" />
                </div>
            </div>

            <div className="boxRight">
                <div className="boxLeft c7h">
                    <video width="320" height="240" autoPlay={true} preload="none" playsInline={true} controls loop muted src={urlMedia + "/testimonios/sinotrukeros/testimonial3.mp4"} className="videoWidth" />
                </div>
            </div>

            <div className="boxRight">
                <div className="boxLeft c7h">
                    <video width="320" height="240" autoPlay={true} preload="none" playsInline={true} controls loop muted src={urlMedia + "/testimonios/sinotrukeros/testimonial4.mp4"} className="videoWidth" />
                </div>
            </div>

            <div className="boxRight">
                <div className="boxLeft c7h">
                    <video width="320" height="240" autoPlay={true} preload="none" playsInline={true} controls loop muted src={urlMedia + "/testimonios/sinotrukeros/testimonial5.mp4"} className="videoWidth" />
                </div>
            </div>

        </div>
    )
}


function Block2() {
    return (
        < div className="block2 responsive" >
            <video width="1920" height="1076" controls autoPlay={true} playsInline={true} muted loop src={urlMedia + "home/vehinstein-tv.mp4"} className="videoWidth" />
        </div >
    )
}

export default Experiencia